import React from "react";
import { IconLoader2 } from "@tabler/icons-react";

type Props = {
    message?: string;
    detail?: string;
};

const SrFaceCheckLoading = ({
    message = "Checking face...",
    detail = "Comparing this photo with registered faces.",
}: Props) => (
    <div className="flex min-h-[280px] flex-col items-center justify-center rounded-xl bg-slate-50 px-6 py-10 text-center">
        <IconLoader2 size={36} className="mb-4 animate-spin text-blue-600" />
        <p className="text-base font-semibold text-gray-900">{message}</p>
        <p className="mt-2 text-sm text-gray-500">{detail}</p>
    </div>
);

export default SrFaceCheckLoading;
